import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const loginField = {
    email: {
        name: 'email',
        rules: {required: true},
        variant: 'standard',
        type: 'email',
    },
    password: {
        name: 'password',
        rules: {required: true},
        variant: 'standard',
        type: 'password',
    },
}
const loginFieldValidation = z.object({
    email: ZodConfig.string().email({message: 'email'}),
    password: ZodConfig.string().min(6, {message: 'password'}),
})

const twoFactorField = {
    code: {
        name: 'code',
        rules: {required: true},
        variant: 'standard',
        inputProps: {maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*'},
    },
}
const twoFactorFieldValidation = z.object({
    code: z.string().length(6, {message: 'code'}),
})

export {loginField, loginFieldValidation, twoFactorField, twoFactorFieldValidation}
